import classnames from 'classnames';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { listerClickThrough } from '../../actions/lister-actions';
import useCardView from '../../hooks/useCardView';
import TRANSLATIONS from '../../translations/translations@default.json';

const MoreInfo = ({ FullProductUrl, Code, classes }) => {
	const { isDealsPage } = useSelector((state) => state);
	const { isListView } = useCardView();

	const dispatch = useDispatch();

	const { CustomCategoriesEnabled } = useSelector(
		(state) => state.experimentSwitches
	);

	if (!FullProductUrl) {
		return null;
	}

	return (
		<button
			type="button"
			href={FullProductUrl}
			onClick={(event) => {
				event.preventDefault();
				window.location.assign(FullProductUrl);

				dispatch(listerClickThrough(Code));
			}}
			className={classnames(
				classes,
				'cta cta-secondary btn btn-secondary text-center w-full',
				{
					'mt-2 mb-2 z-20': isDealsPage,
					'md:mb-0': isDealsPage && isListView,
					'w-full z-20': CustomCategoriesEnabled,
				}
			)}
			data-tag-name="more-info-button-"
			data-testid="more-info-button">
			{TRANSLATIONS.productList.productCard.moreInfoButton}
		</button>
	);
};

export default MoreInfo;
